// Source unique de l'arborescence du programme (vraies ressources).
// Utilisée par l'espace cliente (ClientPhase) ET le dossier admin (ClientDossier)
// pour un verrouillage granulaire par ressource ET sous-page.

export const PROGRAM = [
  {
    phase: 1,
    title: "Mise en place & Stratégie",
    groups: [
      {
        duration: "Semaine 1 → Semaine 2",
        items: [
          {
            slug: "the-success-foundations", emoji: "🔒", label: "The Success Foundations",
            children: [
              { slug: "direction", emoji: "👁️", label: "Direction", children: [
                { slug: "capsules-audio", emoji: "🎧", label: "Capsules audio d'activation" },
              ]},
              { slug: "cible", emoji: "👩🏻", label: "Cible", children: [
                { slug: "prompt-cible", emoji: "📄", label: "Prompt ChatGPT — Cible" },
              ]},
              { slug: "positionnement", emoji: "💵", label: "Positionnement", children: [
                { slug: "prompt-methode", emoji: "📄", label: "Prompt ChatGPT — Méthode" },
                { slug: "capsules-audio-abondance", emoji: "🎧", label: "Capsules audio d'activation" },
              ]},
              { slug: "identite", emoji: "🫦", label: "Identité" },
            ],
          },
        ],
      },
      {
        duration: "Semaine 3 → Semaine 5",
        items: [
          {
            slug: "strategie-contenu", emoji: "🧲", label: "Stratégie de contenu organique",
            children: [
              { slug: "resume-strategie-organique", emoji: "💸", label: "Résumé de ta stratégie organique" },
              { slug: "methode-3c", emoji: "💰", label: "Ma méthode des 3C" },
              { slug: "piliers-contenu", emoji: "🧞‍♂️", label: "Tes piliers de contenu" },
              { slug: "ressources-story", emoji: "👁️", label: "Ressources — story à la une" },
              { slug: "banque-idees", emoji: "💌", label: "Banque d'idées de contenus", to: "/espace/creation-contenu?onglet=idees&sous=insp" },
              { slug: "adapter-contenu", emoji: "⭐️", label: "Apprendre à bien adapter un contenu", children: [
                { slug: "prompt-adapter", emoji: "🤖", label: "Prompt ChatGPT — Décoder un contenu" },
              ]},
              { slug: "accroches", emoji: "✋🏻", label: "Les différentes accroches" },
              { slug: "manychat", emoji: "🤖", label: "Tuto ManyChat" },
            ],
          },
          { slug: "capsules-audio-contenu", emoji: "🎧", label: "Capsule d'audios d'activation" },
        ],
      },
      {
        duration: "Semaine 6",
        items: [
          {
            slug: "strategie-vente", emoji: "💸", label: "Stratégie de vente",
            children: [
              { slug: "trame-appel", emoji: "📞", label: "Ta trame d'appel" },
              { slug: "repondre-objections", emoji: "🚫", label: "Répondre aux objections" },
              { slug: "process-setting", emoji: "💬", label: "Ton process de setting" },
            ],
          },
        ],
      },
    ],
  },
  {
    phase: 2,
    title: "Exécution & Optimisation",
    groups: [
      {
        duration: "Semaine 7 → Semaine 12",
        items: [
          { slug: "analyse-contenus", emoji: "📊", label: "Analyse de tes contenus" },
          { slug: "capsules-audio-phase2", emoji: "🎧", label: "Capsule d'audios d'activation" },
        ],
      },
    ],
  },
];

// Programme sur mesure (clientes en ré-accompagnement).
export const PROGRAM_CUSTOM = [
  {
    phase: 1,
    title: "Audit et restructuration de ton business",
    groups: [{ items: [
      { slug: "audit-direction", label: "Direction" },
      { slug: "audit-cible", label: "Cible et positionnement" },
      { slug: "audit-offres", label: "Offre" },
    ] }],
  },
  { ...PROGRAM[1], groups: PROGRAM[1].groups.map((g) => ({ ...g, duration: null })) },
];

export const programFor = (custom) => (custom ? PROGRAM_CUSTOM : PROGRAM);

// Liste plate de tous les slugs du programme.
export function allSlugs(custom = false) {
  const out = [];
  const walk = (nodes) => nodes.forEach((n) => { out.push(n.slug); if (n.children) walk(n.children); });
  programFor(custom).forEach((ph) => ph.groups.forEach((g) => walk(g.items)));
  return out;
}

// Aplatit un tableau d'items (avec leurs children) en [{ node, depth }].
export function flattenItems(items, depth = 0, out = []) {
  items.forEach((n) => {
    out.push({ node: n, depth });
    if (n.children) flattenItems(n.children, depth + 1, out);
  });
  return out;
}
